// eslint-disable-next-line import/prefer-default-export
export function convertFractionToPercent(fractionNumber, decimals = 0) {
  return (fractionNumber * 100).toFixed(decimals);
}
